export default __webpack_public_path__ + "/dist/images/image00018.ba7cced010831d5c13ca63695986c273.jpg";